// extracted by mini-css-extract-plugin
export default {"cedentManagement":"CedentManagement_cedentManagement__hlaK3","title":"CedentManagement_title__LKCZb"};